import { render, staticRenderFns } from "./ColumnQ.vue?vue&type=template&id=62e64055"
import script from "./ColumnQ.vue?vue&type=script&lang=js"
export * from "./ColumnQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports